// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__W2wsV","notes":"Notes_notes__KpAPr"};